export class SaveCustomerNoteInput {
    customerId: number;
    value: string;
    createdBy?: number;
}